var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCircleGraphic = function SvgCircleGraphic(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 105,
    height: 290,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#32E6F9",
    strokeMiterlimit: 10,
    clipPath: "url(#circle-graphic_svg__a)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-23.11 98.6 10.08 9.02M-17.78 100.94 25.75 15.9M-12.76 103.9 40.5 24.59M-8.13 107.42l62.25-72.47M-3.94 111.47l70.36-64.62M-.26 115.99l77.49-55.87M2.86 120.9 86.4 74.57M5.38 126.15 93.8 90M7.26 131.66l92.07-25.46M8.47 137.36l94.44-14.42M9.01 143.15l95.48-3.17M8.86 148.98l95.19 8.11M8.02 154.74l93.57 19.29M6.51 160.36l90.64 30.19M4.35 165.77l86.44 40.67M1.56 170.88l81.04 50.59M-1.81 175.63l74.5 59.8M-5.71 179.95l66.92 68.17M-10.1 183.77l58.41 75.6M-14.91 187.05l49.08 81.96M-20.08 189.75l39.07 87.17M-25.52 191.81l28.51 91.18"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "circle-graphic_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M-185 0h289.51v289.42H-185z"
  })))));
};
export default SvgCircleGraphic;